module.exports = __webpack_public_path__ + "static/29-c57362d6353cf5710b5af1a1ac4f5195.png";